/** Sufixo do produto em todo título. Mantém a aba reconhecível na barra. */
export const TITLE_SUFFIX = "myGROW";

/**
 * Rótulo de cada rota, na ordem em que é testado.
 *
 * Ordem importa: os padrões mais específicos vêm primeiro, senão
 * `/projects/:id/runs` casaria com `/projects` e a aba diria "Projects" em todas
 * as telas do projeto — que é o defeito de origem, só um pouco menor.
 *
 * Os valores são chaves i18n: o título da aba acompanha o idioma como o resto.
 */
const ROUTE_TITLES: { pattern: RegExp; key: string }[] = [
  { pattern: /^\/login$/, key: "Sign in" },
  { pattern: /^\/profile$/, key: "Profile" },
  { pattern: /^\/admin\/team$/, key: "Team" },
  { pattern: /^\/admin\/settings$/, key: "Settings" },
  { pattern: /^\/admin\/integration$/, key: "Integration" },
  { pattern: /^\/admin\/reference-data(\/.*)?$/, key: "Reference Data" },
  // Retorno do login ADT (S-070). Fica fora do `AppLayout` e por isso passava
  // despercebido nesta tabela — a aba dizia "Not found" sobre a tela que
  // confirma a conexão.
  { pattern: /^\/adt\/connected$/, key: "SAP connection" },
  { pattern: /^\/projects\/[^/]+\/runs$/, key: "Runs" },
  { pattern: /^\/projects\/[^/]+\/artifacts$/, key: "Artifacts" },
  { pattern: /^\/projects\/[^/]+\/connections$/, key: "Connections" },
  { pattern: /^\/projects\/[^/]+\/cost$/, key: "Cost & Tokens" },
  { pattern: /^\/projects\/[^/]+\/settings$/, key: "Project settings" },
  { pattern: /^\/projects\/[^/]+\/calibration$/, key: "Calibration" },
  { pattern: /^\/projects\/[^/]+\/commercial-calibration$/, key: "Commercial calibration" },
  { pattern: /^\/projects\/[^/]+\/diagnostic(\/.*)?$/, key: "Diagnostic" },
  { pattern: /^\/projects\/[^/]+\/agents\/.+$/, key: "Agent" },
  { pattern: /^\/projects\/[^/]+$/, key: "Project" },
  { pattern: /^\/projects$/, key: "Projects" },
  { pattern: /^\/$/, key: "Agentic AI for SAP migration" },
];

/** `"Projects · myGROW"`. Rota desconhecida cai no 404, que também tem nome —
 *  uma aba escrita só "myGROW" é o problema que este módulo existe para tirar. */
export function titleForPath(pathname: string, t: (k: string) => string): string {
  const match = ROUTE_TITLES.find((entry) => entry.pattern.test(pathname));
  return `${t(match ? match.key : "Not found")} · ${TITLE_SUFFIX}`;
}
